<template lang="pug">
	.audio-tracker-master-track-head-panel
		.flex-row.space.center.align-center(v-if="!hidden")
			.flex-row.align-center.center.full-height.space
				AudioTrackerButtonGroup
					AudioTrackerButton(v-for="plugin in wapiPlugins", :icon="plugin.icon", @click="v => showWAPIPlugin(plugin.id)", :active="getWapiActivePlugin(plugin.id).enabled", :title="plugin.name()")
					AudioTrackerButton(@click="v => $refs.wapiPluginsManager.show()", icon="fas fa-gears", :title="$tCaption('Effects manager')")
				.flex-col
					.flex-row.flex-1.center
						.font-tiny.upper.grey {{$tCaption('Master volume')}}
					AudioTrackerSliderButton(:min="0", :max="1", :step="0.01", :round="2", orientation="horizontal", length="130px", v-model="innerConfig.volume", handleWidth="14px", handleSize="28px", :isLogarithmic="true")
				.flex-row.space
					AudioTrackerVUMeter(ref="VUMeter", orientation="horizontal", :step="0.1", :showRulerMaxValues="false", :tickVisible="false", size="150px", thickness="5px", :isPlaying="tracker.isPlaying", :filters="filters")
					.flex-col.center.panel-indicator.peak(v-if="$refs.VUMeter")
						.font-tiny.upper.grey.flex-row.flex-1.center.align-center {{$tCaption('Peak')}}
						.flex-row.flex-1.center.align-center.value.font-small {{formatDBValue($refs.VUMeter.peakDbLevel)}} dB
			.flex-col.space.master-track-actions
				.flex-row.button.hover.align-center.center(@click="showPostEffects(true)", :class="{ 'active': innerConfig.postEffects.plugins.length }") {{$tCaption('MASTER')}}
		AudioTrackerPostEffectsPopup(:visible.sync="postEffectsVisible", :postEffects="innerConfig.postEffects", :tracker="tracker", :audioContext="audioContext", :headerCaption="$auth.hasProAudio() ? $tCaption('Master plugins') : $tCaption('Master effects')")
			template(v-slot:post-effects-left="data")
				slot(name="post-effects-left", v-bind="data", :postEffects="innerConfig.postEffects")
		WAPIPluginPopup(ref="wapiPlugin", :plugins="innerConfig.wapiPlugins", :audioContext="audioContext", :source="getSource", @cancel="onWapiPluginCancel", :playing="tracker.isPlaying", :tracker="tracker")
		WAPIPluginsManager(ref="wapiPluginsManager", :plugins="innerConfig.wapiPlugins", :tracker="tracker", , @open="plugin => showWAPIPluginInstance(plugin.instance)")
</template>


<script>
	import _ from  'lodash';
	import VueTypes from 'vue-types';
	import AudioTrackerSliderButton from './AudioTrackerSliderButton.vue';
	import AudioTrackerVUMeter from './AudioTrackerVUMeter.vue';
	import Popup from 'app-core/Popup.vue';
	import AudioTrackInfoPanelPostEffects from './AudioTrackInfoPanelPostEffects.vue';
	import DxButton from 'devextreme-vue/button';	
	import pluginsList from 'view/audioTracker/plugins/plugins-list';
	import WAPIPluginPopup from 'view/audioTracker/plugins/WAPIPluginPopup.vue';
	import WAPIPluginsManager from './plugins/WAPIPluginsManager.vue';
	import AudioTrackerPostEffectsPopup from './AudioTrackerPostEffectsPopup.vue';
	import AudioTrackerButton from './AudioTrackerButton.vue';
	import AudioTrackerButtonGroup from './AudioTrackerButtonGroup.vue';

	export default {
		translationCategory: 'audioTracker.AudioTrackerMasterTrack',
		name: 'audio-tracker-master-track',
		components: { 
			AudioTrackerSliderButton, AudioTrackerVUMeter, Popup, AudioTrackInfoPanelPostEffects, DxButton, WAPIPluginPopup, WAPIPluginsManager, AudioTrackerPostEffectsPopup, 
			AudioTrackerButtonGroup, AudioTrackerButton },
		props: {
			audioContext: VueTypes.any.def(null),
			tracker: VueTypes.any.def(null),
			config: VueTypes.any.def(null),
			filters: VueTypes.any.def(null),
			hidden: VueTypes.bool.def(false)
		},
		data() {
			return {
				innerConfig: _.cloneDeep(this.config),
				postEffectsVisible: false,
				initWapiPlugins: []
			};
		},
		watch: {
			innerConfig: {
				handler() {
					if (!this.$isConfigSetting)
						this.$emit('changed', this.innerConfig);
				},
				deep: true
			},
			config: {
				handler(v) {
					this.setConfig(v);
				},
				deep: true
			}
		},
		computed: {
			wapiPlugins() {
				return pluginsList.plugins.map(p => {
					return {
						...p,
						icon: p.icon || 'fas fa-microchip'
					}
				});
			}
		},
		mounted() {
			if (__DEBUG__)
				window.masterTrack = this;
		},
		destroyed() {

		},
		methods: {
			setConfig() {
				this.$isConfigSetting = true;
				this.innerConfig = _.cloneDeep(this.config);
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.$isConfigSetting = false;
				});
			},
			getWapiActivePlugin(id) {
				let existingPlugin = this.config?.wapiPlugins?.filter(f => f.id === id && f.enabled === true)[0];
				if (!existingPlugin)
					existingPlugin = this.config?.wapiPlugins?.filter(f => f.id === id)[0];
				return existingPlugin || { enabled: false };
			},
			showPostEffects(v) {
				this.postEffectsVisible = false;
				if (v)
					setImmediate(() => {
						this.postEffectsVisible = true;
					})
			},
			formatDBValue(val) {
				return parseFloat((isNaN(val) || val == null) ? -60 : val).toFixed(1);
			},
			showWAPIPlugin(pluginId) {
				if (__DEBUG__)
					console.debug('Show wapi plugin', { pluginId });
				var plugin = this.getWapiActivePlugin(pluginId);
				this.$refs.wapiPlugin?.showPopup(pluginId, plugin, plugin?.instanceId);
				this.initWapiPlugins = _.cloneDeep(this.config?.wapiPlugins);
			},
			showWAPIPluginInstance(instance) {
				this.$refs.wapiPlugin?.showPopup(instance.id, instance, instance.instanceId);
			},
			onWapiPluginCancel() {
				if (__DEBUG__)
					console.debug('onWapiPluginSave');
				this.config.wapiPlugins = _.cloneDeep(this.initWapiPlugins);
				this.$emit('changed', this.innerConfig);
			},
			async getSource() {
				return {
					...this.tracker.masterTrackSource,
					source: {
						play: () => { this.tracker.play(0); },
						stop: () => { this.tracker.stop(); }
					}
				};
			}
		}
	};
</script>
<style lang='scss'>
	.audio-tracker-master-track-head-panel {
		@import "main/themes/generated/variables.base.scss";

		height: 100%;
		user-select: none;

		.master-track-actions {
			padding: 2px;

			.ui-button {
				background: #484856;

				&.active {
					background: $base-accent;
					color: $base-bg;
				}
			}
		}

		.audio-tracker-vumeter .vu-meter {
			position: relative;
			background: #c5c5c5 !important;

			.borders {
				background-image: linear-gradient(90deg, transparent 0px, transparent calc(var(--tile-width) - 1px), #e2e2e2 calc(var(--tile-width) - 1px))
			}

			.db-peak {
				background: #6b6b6b;
			}
		}

		.panel-indicator {
			&.peak {
				min-width: 60px;
			}
		}
	}

	.audio-track-info--post-effects {
		.master-post-effects-list {
			min-height: 300px;
		}
	}
</style>
